import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { AuthLayout } from '@components';
import {
  useAsyncInit,
  useNavOptionsSet,
  usePersonalizationNavigation,
} from '@hooks';
import { useViewerModel } from '@models/Viewer/ViewerModel';
import { ToastService } from '@services';
import { IS_WEB, parseApiError } from '@utils';
import { SuggestedUsersList } from './components/SuggestedUsersList';

export const UsersSuggestionScreen = observer(() => {
  const { t } = useTranslation();
  const { navigateToHome } = usePersonalizationNavigation();
  const viewer = useViewerModel();

  useNavOptionsSet({ title: t('usersSuggestion.title') });

  useEffect(() => {
    // On web user can reach this page by entering route in address bar
    // We check if need to suggest friends for user if no need we will redirect him to
    // home page
    if (
      IS_WEB &&
      !viewer.currentUser?.settings.isNeedToSuggestUsers
    ) {
      navigateToHome();
    }
  }, []);

  useAsyncInit(async () => {
    try {
      await viewer.usersSuggestion.list.fetch.run();
    } catch (e) {
      ToastService.showError(parseApiError(e).message);
    }
  });

  return (
    <AuthLayout isAuthorized={true}>
      <SuggestedUsersList list={viewer.usersSuggestion.list} />
    </AuthLayout>
  );
});
